<template>
	<el-card shadow="never">
		<div class="header-row" slot="header">
			<div class="title">经营数据总览</div>
			<div style="color: #409eff; font-size: 14px; cursor: pointer" @click="goPage(null)">更多</div>
		</div>
		<div class="data-grid">
			<div class="data-item" v-for="(item, index) in dataList" :key="index" :style="{ '--color': item.color }">
				<div class="description">
					<div>{{ item.label }}</div>
					<div class="tip" v-if="item.info">
						<el-tooltip class="item" effect="dark" content="收缴率=本月实收租金/本月应收租金× 100%" placement="top">
							<i class="fa fa-question-circle-o" style="color: #999; font-size: 14px"></i>
						</el-tooltip>
					</div>
				</div>
				<div class="value">{{ item.header }}{{ item.value }}{{ item.unit }}</div>
			</div>
		</div>
	</el-card>
</template>

<script>
	export default {
		name: 'BusinessDataOverview',
		data() {
			return {
				dataList: [
					{
						value: '0',
						unit: '万元',
						header: '¥',
						label: '本月应收租金',
						color: '#2B8CEE',
						key: 'monthlyReceivableRent',
					},
					{ value: '0', unit: '万元', header: '¥', label: '本月实收租金', color: '#16A34A', key: 'monthlyActualRent' },
					{ value: '0', unit: '%', header: '', label: '收缴率', color: '#0F172A', info: true, key: 'collectionRate' },
					{
						value: '0',
						unit: '份',
						header: '',
						label: '本月到期合同',
						color: '#EF4444',
						key: 'monthlyExpiringContracts',
					},
				],
			};
		},
		props: {
			businessOverview: {
				type: Object,
				default: () => ({}),
			},
		},
		watch: {
			businessOverview: {
				handler(newVal) {
					if (!newVal) return;
					this.dataList.forEach(item => {
						item.value = newVal[item.key] !== undefined ? newVal[item.key] : '0';
					});
				},
			},
		},
		methods: {
			goPage(url) {
				if (!url) return;
				this.$router.push(url);
			},
		},
	};
</script>

<style scoped lang="scss">
	.header-row {
		display: flex;
		justify-content: space-between;
		height: 20px;
	}

	.title {
		font-weight: bold;
	}
	.data-grid {
		width: 100%;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		gap: 12px;
	}

	.data-item {
		width: calc(100% / 4 - 12px);
		box-sizing: border-box;
		padding: 12px;
		border-radius: 4px;
		cursor: pointer;

		.description {
			font-size: 12px;
			color: #909399;
			display: flex;
			align-items: center;
			gap: 8px;
		}

		.tip {
			cursor: help;
		}

		.value {
			font-size: 24px;
			font-weight: bold;
			color: var(--color);
			margin-top: 4px;
		}
	}
</style>
